class Aidf {
  constructor() {
    this.id = null;
    this.idCliente = null;
    this.idContribuinte = null;
    this.contribuinte = null;
    this.numeroAidf = 0;
    this.graficaResponsavel = '';
    this.dataSolicitacao = '';
    this.tipoDocumento = '';
    this.numeracaoIni = 0;
    this.numeracaoFin = 0;
    this.serie = '';
    this.quantidade = 0;
    this.situacao = '';
    this.observacoes = '';
  }
}

export default Aidf;